// Hooks
import { createFormContext, useForm } from '../../../hooks';

export const ProfileContext = createFormContext();

export const useProfile = useForm;
export default useProfile;
